module.exports = __webpack_public_path__ + "img/jump_scare_splash.12fda838.jpg";